(function () {
  'use strict';

  angular.module('sempraWebapp').factory('reportsFilterStore', reportsFilterStoreFactory);

  /** @ngInject */
  function reportsFilterStoreFactory (dispatcher, EventEmitter, DateTime, ActionTypesEnum) {
    var ReportFiltersStore = new EventEmitter(),
      filterDataImmutable = Immutable.fromJS({
        fromTimestamp: new DateTime().startOf(DateTime.units.MONTH).timestamp,
        toTimestamp: new DateTime().endOf(DateTime.units.DAY).timestamp,
        selectedFacilitySerial: null,
        period1From: 1,
        period1To: 12,
        period2From: moment().year(),
        period2To: moment().year() - 1,
        period3From: 0,
        period3To: 24,
        currency: 'EUR'
      });

    ReportFiltersStore.events = Object.freeze({
      CHANGE: 'change'
    });

    ReportFiltersStore.getFilterData = function () {
      return filterDataImmutable !== null
        ? filterDataImmutable.toJSON()
        : null;
    };

    ReportFiltersStore.dispatchToken = dispatcher.register(function (actionData) {
      var updatedData = filterDataImmutable.toJSON();

      switch (actionData.type) {

        case ActionTypesEnum.UPDATE_REPORT_FILTER:

          if (actionData.payload.fromTimestamp) {
            updatedData.fromTimestamp = actionData.payload.fromTimestamp;
          }
          if (actionData.payload.toTimestamp) {
            updatedData.toTimestamp = actionData.payload.toTimestamp;
          }
          if (actionData.payload.selectedFacilitySerial) {
            updatedData.selectedFacilitySerial = actionData.payload.selectedFacilitySerial;
          }
          if (actionData.payload.period1From) {
            updatedData.period1From = actionData.payload.period1From;
          }
          if (actionData.payload.period1To) {
            updatedData.period1To = actionData.payload.period1To;
          }
          if (actionData.payload.period2From) {
            updatedData.period2From = actionData.payload.period2From;
          }
          if (actionData.payload.period2To) {
            updatedData.period2To = actionData.payload.period2To;
          }
          if (actionData.payload.currency) {
            updatedData.currency = actionData.payload.currency;
          }
          if (actionData.payload.period3From !== null || actionData.payload.period3From !== angular.isUndefined) {
            updatedData.period3From = actionData.payload.period3From;
          }
          if (actionData.payload.period3To !== null || actionData.payload.period3To !== angular.isUndefined) {
            updatedData.period3To = actionData.payload.period3To;
          }
          filterDataImmutable = Immutable.fromJS(updatedData);
          ReportFiltersStore.emit(ReportFiltersStore.events.CHANGE);
          break;
      }
    });

    return ReportFiltersStore;
  }
})();
